import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleShoes() {
  return <ArticleTemplate slug="sugargoo-shoes-guide" />;
}